module.exports = __webpack_public_path__ + "assets/voice/new_take_away.MP3";